import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSearch }  from '@fortawesome/fontawesome-pro-regular';
import { NsbaHorseSearchService } from '../../../providers/nsba-horse-search.service';
import { Nsba_horse } from '../../../models/nsba_horse';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-nsba-horse-search',
  templateUrl: './modal-nsba-horse-search.component.html',
styleUrls:  ['./modal-nsba-horse-search.component.css']
})
export class ModalNsbaHorseSearchComponent extends SmsAbstractAppPage implements OnInit {

	faSearch = faSearch;
	search_results: Nsba_horse[] = [];
	horse_selected$: EventEmitter<Nsba_horse> = new EventEmitter<Nsba_horse>();

  constructor(public activeModal: NgbActiveModal, private nsbaHorseSearchService: NsbaHorseSearchService) {
  	super();
  }

  ngOnInit() {
  }

  handleSearch(search_term: string){
  	this.nsbaHorseSearchService.getByTerm(search_term).then(search_results => {
  		this.search_results = search_results;
      document.getElementById('list-search-results').scrollIntoView();
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

	handleSelect(nsba_horse: Nsba_horse){
		this.horse_selected$.emit(nsba_horse);
	}

}
